import { Platform } from '@ionic/angular';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import SignaturePad from 'signature_pad';
import { NumberType } from 'libphonenumber-js';

@Component({
    selector: 'app-signature',
    templateUrl: './signature.component.html',
    styleUrls: ['./signature.component.scss'],
    standalone: false
})
export class SignatureComponent implements OnInit
{

	@Input() id: string;
	@Input() value: string;
	@Input() classes: string;

	@Output() mcChange: EventEmitter<string> = new EventEmitter<string>();

	@ViewChild('canvas', { static: true }) signaturePadElement;
	signaturePad: any;

	public signaturePadOptions: Object;

	constructor(
		private elementRef: ElementRef,
		private platform: Platform)
	{

	}

	public ngOnInit()
	{
		this.init();
	}

	public init()
	{
		var offset = 68;
		var subtract = 0;

		if (this.platform.width() > 948)
		{
			this.canvasWidth = 948;
		}
		else
		{
			this.canvasWidth = this.platform.width();
		}
		this.canvasHeight = (this.canvasWidth / 2) * .75;
		if (this.canvasHeight < 200)
		{
			this.canvasHeight = 200;
		}

		const canvas: any = this.elementRef.nativeElement.querySelector('canvas');
		canvas.width = this.canvasWidth - 74;
		canvas.height = this.canvasHeight; //

		// const ratio =  Math.max(window.devicePixelRatio || 1, 1);
		// canvas.width = canvas.offsetWidth * ratio;
		// console.log(canvas.width);
		// canvas.height = canvas.offsetHeight * ratio;
		// canvas.getContext("2d").scale(ratio, ratio);

		if (this.signaturePad)
		{
			this.signaturePad.clear(); // Clear the pad on init
		}
	}
	canvasWidth: number;
	canvasHeight: number;


	public ngAfterViewInit(): void
	{
		this.signaturePadOptions = {
			'minWidth': 1.5,
			'canvasWidth': this.canvasWidth,
			'canvasHeight': this.canvasHeight,
			'backgroundColor': 'rgb(255, 255, 255)',
			'penColor': '#222222'
		};
		this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement, this.signaturePadOptions);
		this.signaturePad.clear();

		this.signaturePad.addEventListener("beginStroke", () =>
		{
			// console.log("draw started");
			this.signatureStarted = true;
		}, { once: false });
		this.signaturePad.addEventListener("endStroke", () =>
		{
			// console.log("Signature ended");
			var signature = this.signaturePad.toDataURL("image/jpeg");
			// console.log(signature);
			this.mcChange.emit(signature);
		}, { once: true });
	}

	signatureStarted: boolean = false;

	@HostListener('window:orientationchange', ['$event'])
	onResize(event)
	{
		this.init();
	}

	save(): void
	{
		const img = this.signaturePad.toDataURL();
	}

	isCanvasBlank(): boolean
	{
		if (this.signaturePad)
		{
			return this.signaturePad.isEmpty() ? true : false;
		}
	}
	clear()
	{
		this.signaturePad.clear();
		this.signatureStarted = false;
		this.init();
	}

	undo()
	{
		const data = this.signaturePad.toData();
		if (data)
		{
			data.pop(); // remove the last dot or line
			this.signaturePad.fromData(data);
		}
	}

}
